const iframeRegex = /<iframe(.*)src=["'](.*?)['"]/i
const imageRegex = /<img(.*)src=["'](.*?)['"]/i
const urlRegex =
  /(((ftp|http|https):\/\/)|(\/)|(..\/))(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\\/]))?/
//const domainRegex = /(?:http|https):\/\/((?:[\w-]+)(?:\.[\w-]+)+)(?:[\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/i;

// eslint-disable-next-line no-unused-vars
const getYouTubeVideoIdFromUrl = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[2].length === 11 ? match[2] : undefined
}

// eslint-disable-next-line no-unused-vars
const getVimeoIdFromUrl = (url) => {
  const match = /vimeo.*\/(\d+)/i.exec(url)
  if (match) {
    return match[1]
  }
  return null
}

// eslint-disable-next-line no-unused-vars
const generateYouTubeUrl = (videoId) => {
  return `//www.youtube.com/embed/${videoId}`
}

// eslint-disable-next-line no-unused-vars
const generateVimeoUrl = (videoId) => {
  return `https://player.vimeo.com/video/${videoId}`
}

export default {
  computed: {
    isImage() {
      if (imageRegex.exec(this.url)) {
        return true
      }

      return false
    },
    isIframe() {
      return !this.isImage
    },
    isValid() {
      let url = null
      let m = null

      if ((m = iframeRegex.exec(this.url)) !== null) {
        url = m[2]
      } else if ((m = imageRegex.exec(this.url)) !== null) {
        url = m[2]
      } else {
        url = this.url
      }

      if ((m = urlRegex.exec(url)) !== null) {
        // 1) is youtube?
        let youtubeId = getYouTubeVideoIdFromUrl(url)
        if (youtubeId) {
          return generateYouTubeUrl(youtubeId)
        }

        // 2) is vimeo?
        let vimeoId = getVimeoIdFromUrl(url)
        if (vimeoId) {
          return generateVimeoUrl(vimeoId)
        }

        // 3) another source = leave it as it is :)
        return url
      }

      return false
    }
  }
}
